import StoryblokService from "@lib/storyblok/templates/storyblok-service.class";
class ImagesStoryblokService extends StoryblokService {
  constructor() {
    super();
    this.baseURL += "/financial_entity/images";
  }
  async getPasswordResetSuccessfullyImage() {
    return this.getSingleImage("".concat(this.baseURL, "/password_reset_successfully"));
  }
  async getAccountCreatedSuccessfullyImage() {
    return this.getSingleImage("".concat(this.baseURL, "/account_created_successfully"));
  }
  async getMaintenanceImage() {
    return this.getSingleImage("".concat(this.baseURL, "/maintenance"));
  }
  async getMinimumPointsModalImage() {
    return this.getSingleImage("".concat(this.baseURL, "/minimum_points_modal"));
  }
  async getYouCouldLoseYourReservationModalImage() {
    return this.getSingleImage("".concat(this.baseURL, "/lose_reservation_warning"));
  }
  async getItinerarySentSuccessfullyModalImage() {
    return this.getSingleImage("".concat(this.baseURL, "/itinerary_sent_successfully"));
  }
}
const imagesStoryblokService = new ImagesStoryblokService();
export default imagesStoryblokService;